import {
  Briefcase,
  Hammer,
  HardHat,
  BrickWall,
  Sparkles,
  BrushCleaning,
  Trees,
  Shovel,
  Truck,
  Package,
  Zap,
  Wrench,
  Paintbrush,
  PaintRoller,
  Drill,
  Flame,
  KeyRound,
  House,
  Ruler,
  PencilRuler,
  Code,
  Laptop,
  Smartphone,
  Monitor,
  Camera,
  Wifi,
  ChefHat,
  Coffee,
  UtensilsCrossed,
  Car,
  Bus,
  Bike,
  Plane,
  Baby,
  PawPrint,
  Heart,
  Stethoscope,
  BookOpen,
  GraduationCap,
  Calculator,
  Sofa,
  Lightbulb,
  Plug,
  Leaf,
  Sprout,
  Scissors,
  Shirt,
  Palette,
  Music,
  Gift,
} from 'lucide-react'

const ICON_MAP = {
  briefcase: Briefcase,
  hammer: Hammer,
  'hard-hat': HardHat,
  'brick-wall': BrickWall,
  sparkles: Sparkles,
  'brush-cleaning': BrushCleaning,
  trees: Trees,
  shovel: Shovel,
  truck: Truck,
  package: Package,
  zap: Zap,
  wrench: Wrench,
  paintbrush: Paintbrush,
  'paint-roller': PaintRoller,
  drill: Drill,
  flame: Flame,
  'key-round': KeyRound,
  house: House,
  ruler: Ruler,
  'pencil-ruler': PencilRuler,
  code: Code,
  laptop: Laptop,
  smartphone: Smartphone,
  monitor: Monitor,
  camera: Camera,
  wifi: Wifi,
  'chef-hat': ChefHat,
  coffee: Coffee,
  'utensils-crossed': UtensilsCrossed,
  car: Car,
  bus: Bus,
  bike: Bike,
  plane: Plane,
  baby: Baby,
  'paw-print': PawPrint,
  heart: Heart,
  stethoscope: Stethoscope,
  'book-open': BookOpen,
  'graduation-cap': GraduationCap,
  calculator: Calculator,
  sofa: Sofa,
  lightbulb: Lightbulb,
  plug: Plug,
  leaf: Leaf,
  sprout: Sprout,
  scissors: Scissors,
  shirt: Shirt,
  palette: Palette,
  music: Music,
  gift: Gift,
}

export function CategoryIcon({ iconKey, size = 18, strokeWidth = 1.8 }) {
  const Icon = ICON_MAP[iconKey] || Briefcase
  return <Icon size={size} strokeWidth={strokeWidth} />
}
